<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="pages"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class PagesShow extends Vue {
  data = {}

  get columns() {
    return createColumns.call(this, {
      actionColumn: {
        detail: false
      }
    })
  }

  async mounted() {
    this.data = await this.$request.get(`/pages/${this.$route.params.id}`);
  }
}
</script>
